import * as CryptoJS from 'crypto-js';
import moment from 'moment';
import { add, addToCollection, getAllOfTable } from '../offlineManager/localbase';
import { post, updateLogger } from '../api/api';
import JSEncrypt from 'jsencrypt';
import { format } from "date-fns";

import { ApiUrls } from '../api/baseURL';
const encryptSecretKey = "b14ca5898a4e4133bbce2ea2315a1916";
const required = "This field is required";
export const dateFormat = 'yyyy-MM-dd';
export const dateTimeFormat = "YYYY-MM-DD HH:mm:ss"
export const dateTimeFormatWithT = "YYYY-MM-DDTHH:mm:ss"
export const sharepath ="https://fulcrumdigital.sharepoint.com/sites/TAG-India/Shared Documents";
export const RecruitmentPortal ="Onboarding Documents"
export const uuidv4 = () => {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = Math.random() * 16 | 0, v = c === 'x' ? r : (r & 0x3 | 0x8);
        return v.toString(16);
    });
}


// function to encrypt data to send to API
export const encryptApiData = (msg) => {
    var keySize = 256;
    var salt = CryptoJS.lib.WordArray.random(16);
    var key = CryptoJS.PBKDF2(encryptSecretKey, salt, {
        keySize: keySize / 32,
        iterations: 100
    });

    var iv = CryptoJS.lib.WordArray.random(128 / 8);

    var encrypted = CryptoJS.AES.encrypt(msg, key, {
        iv: iv,
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    });
    return CryptoJS.enc.Base64.stringify(salt.concat(iv).concat(encrypted.ciphertext));
}

// function to decrypt data from API
export const decryptApiData = (ciphertext) => {

    var key = CryptoJS.enc.Utf8.parse(encryptSecretKey);
    var iv = CryptoJS.lib.WordArray.create([0x00, 0x00, 0x00, 0x00]);

    var decrypted = CryptoJS.AES.decrypt(ciphertext, key, { iv: iv });
    return decrypted.toString(CryptoJS.enc.Utf8);
}

// function to encrypt the localstorage
export const encryptData = (data) => {
    return CryptoJS.AES.encrypt(JSON.stringify(data), encryptSecretKey).toString();

}

export const decrypt = (data) => {
    const crypt = new JSEncrypt();
    const privateKey = localStorage.getItem("privateKey");
    crypt.setPrivateKey(privateKey);
    return crypt.decrypt(data);
}

export const userData = () => {
    const userDetails = JSON.parse(localStorage.getItem("persist:root"));
    return JSON.parse(userDetails.userReducer).profileInfo.userId;
}

// function to decrypt the localstorage
export const decryptData = (data) => {
    if (!data) {
        return ''
    }
    const bytes = CryptoJS.AES.decrypt(data, encryptSecretKey);
    console.log(bytes, "BYTES!!")
    return JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
}

// function to set the data into session storage
export const setSession = (key, value) => {
    return  sessionStorage.setItem(key, encryptData(value));
}

// function to get the data from session storage
export const getSession = (key) => {
    const encryptedData = sessionStorage.getItem(key)
    return decryptData(encryptedData);
}

// function to set the data into session storage
export const setLocalStorage = (key, value) => {
    return localStorage.setItem(key, encryptData(value));
}

// function to get the data from session storage
export const getLocalStorage = (key) => {
    const encryptedData = localStorage.getItem(key);
    return decryptData(encryptedData);
}

export const checkIsMobile = () => {
    return navigator && navigator.userAgentData && navigator.userAgentData.mobile ? navigator.userAgentData.mobile : false;
}

export const isUserSame = (assigneto, userId) => {
    return parseInt(assigneto) === parseInt(userId)
}

//GET MOBILE OS
export const getMobileOS = () => {

    const ua = navigator.userAgent

    if (/android/i.test(ua)) {
        return "Android"
    }

    else if ((/iPad|iPhone|iPod/.test(ua)) || (navigator.platform === 'MacIntel' && navigator.maxTouchPoints > 1)) {
        return "iOS"
    }

    return "Other"
}

export const getBuildDate = (epoch) => {
    return  moment(epoch).format("DD-MM-YYYY HH:MM");
}
export const getUniqueDeviceId = () => {
    // eslint-disable-next-line no-undef
    return new DeviceUUID().get();
}

export const getDateAfterDays = (days) => {
    const date = new Date();
    date.setDate(date.getDate() + days);
    return date;
}

export const logError = async (error,b) => {
    const isOnline = window.navigator.onLine;
    if(isOnline){
        let payload = typeof(error) === 'string' ? error : JSON.stringify(error, Object.getOwnPropertyNames(error))
        return updateLogger(payload, 1)
    } else {
        let timestamp = new Date().toISOString();
        let data = {"ERR" : timestamp + " : " + JSON.stringify(error, Object.getOwnPropertyNames(error))}
        return await addToCollection("OfflineErrorLog", timestamp, data)
    }
}

export const getOfflineFeatures = async (featureName) => {
    const offlineFeatures = await getAllOfTable("FeatureAccess")
    let feat = {}
    if (featureName) {
        offlineFeatures.forEach(feature => {
            if (featureName == Object.keys(feature)) {
                feat[Object.keys(feature)] = feature[Object.keys(feature)]
            }
        })
    } else {
        offlineFeatures.forEach(feature => {
            feat[Object.keys(feature)] = feature[Object.keys(feature)]
        })
    }
    return feat;
}

export const featureHasAccess = (featureName, featureTypeName, obj) => {
    if (obj === null) return
    let hasItem = obj[featureName]?.indexOf(featureTypeName);
    if (hasItem === -1 || hasItem === undefined){
        return false
    } else {
        return true
    }
}

export const getDateWithFormat = (dateformat) => {
    return format(new Date(), dateformat);
}

export const getWeekDay = () => {
    const currentDate = new Date();
    const dayNumber = currentDate.getDay();
    let dayKeyValue = {
        '1': "Monday",
        '2': "Tuesday",
        '3': "Wednesday",
        '4': "Thursday",
        '5': "Friday",
        '6': "Saturday",
        '0': "Sunday",
    }
    return dayKeyValue[dayNumber]
}

export const getPhysicalInventoryCheckOffline = async () => {
    const payload = {
        "IsActive": 1,
        "accountId": 0,
        "workflowModuleKey": "INVENTORY_COUNT_FILL",
        "moduleKey": 1,
        "masterId": 0,
        "timeOffset": -330,
        "isIncludePosted": 0,
        "take": 1000,
        "skip": 0,
        "page": 1,
        "pageSize": 1000
    };
    // setActivateLoader(true)
    const response = await post(ApiUrls().PHYSICAL_INVENTORYCHECK_OFFLINE, payload)
        .catch(function (error) {
            // Handle errors here
            // setActivateLoader(false)
            console.error("Error:", error);
        });
    if (response?.status === 200) {


        const dataObject = {
            physicalInventoryDetails: response?.data.result,
        };
        add("PhysicalInventoryDetails", dataObject)
            .then((res) => {
                console.log(res)
                //   setActivateLoader(false)
                localStorage.setItem("isOnlineSyncRequired", true)
                // window.location.reload()
            })
            .catch((err) => console.log(err));

    }
};

export const getPreviousQuantity = async () => {

    // setActivateLoader(true)
    const response = await post(ApiUrls().OFFLINE_PREVIOUS_QUANTITY, {})
        .catch(function (error) {
            // Handle errors here
            // setActivateLoader(false);
            console.error("Error:", error);
        });

    if (response?.status === 200) {

        const dataObject = {
            previousQuantityDetails: response?.data.result,
        };
        add("PreviousQuantityDetails", dataObject)
            .then((res) => {
                console.log(res)
                // setActivateLoader(false);
                localStorage.setItem("isOnlineSyncRequired", true)
                // window.location.reload()
            })
            .catch((err) => console.log(err));

    }
};